import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { selectedIdfromTableRowTransaction } from "../../../../../../../app/store";
import { useTransactionId } from "../../../../../../../app/hooks/useTransactionId";

export const useTransactionDetails = () => {
  const [selectedId] = useAtom(selectedIdfromTableRowTransaction);
  const navigate = useNavigate();

  const handleGoToSellerPage = (id: string) => {
    navigate(`/vendedores/${id}`);
  };

  const handleGoToCustomerPage = (id: string) => {
    navigate(`/clientes/${id}`);
  };

  const { data, isFetching, isLoading } = useTransactionId(selectedId);

  return {
    data,
    isFetching,
    isLoading,
    handleGoToSellerPage,
    handleGoToCustomerPage,
  };
};
